import "../../styles/hdiassicurazioni/hdiassicurazioni.scss";
import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import HeaderComponent from "./components/HeaderComponent";
import VisualComponent from "./components/VisualComponent";
import MapComponent from "./components/MapComponent";
import MapComponentC from "./components/MapComponentC";
import ProductComponent from "./components/ProductComponent";
import Estimator from "./components/Estimator";
import ExtraInfoCard from "./components/ExtraInfoCard";
import DocumentationBox from "./components/DocumentationBoxComponent";
import $ from 'jquery';
import FooterComponent from "./components/FooterComponent";
import HighlightedProductsCarouselComponent from "./components/HighlightedProductsCarouselComponent";
import ConversationalToolComponent from "./components/ConversationalToolComponent";
import ConversationalToolCardComponent from "./components/ConversationalToolCardComponent";
import NewsListComponent from "./components/NewsListComponent";
import GenericCarouselComponent from "./components/GenericCarouselComponent";
import AccordionComponent from "./components/AccordionComponent";
import EditorialCarouselComponent from "./components/EditorialCarouselComponent";
import QuizComponent from "./components/QuizComponent";
import OtherCategoryInfo from "./components/OherCategoryInfo";
import FormDeceasedDateComponent from "./components/FormDeceasedDateComponent";
import FormIdComponent from "./components/FormIdComponent";
import FormIntTelephone from "./components/FormIntTelephone";
import FormComponent from "./components/FormComponent";
import CardInfoCarComponent from "./components/CardInfoCarComponent";

SmartComponentManager.registerComponents({
    DefaultCtrl,
    HeaderComponent,
    FooterComponent,
    VisualComponent,
    MapComponent,
    MapComponentC,
    ProductComponent,
    Estimator,
    ExtraInfoCard,
    EditorialCarouselComponent,
    HighlightedProductsCarouselComponent,
    DocumentationBox,
    ConversationalToolComponent,
    ConversationalToolCardComponent,
    AccordionComponent,
    NewsListComponent,
    GenericCarouselComponent,
    QuizComponent,
    OtherCategoryInfo,
    FormDeceasedDateComponent,
    FormIdComponent,
    FormIntTelephone,
    FormComponent,
    CardInfoCarComponent
});

$(document).ready(() => {
    let $body = $('body [component="DefaultCtrl"]');
    SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});

